import { StyleSheet, css } from 'aphrodite'
import React from 'react'

interface Statistic {
  value: string
  title: string
}

interface StatisticsSectionProps {
  stats: Statistic[]
}

export default function StatisticsSection({ stats }: StatisticsSectionProps) {
  return (
    <div className={css(styles.container)}>
      {stats.map((stat) => (
        <div
          key={`${stat.value}-${stat.title}`}
          className={css(styles.statItem)}
        >
          <h3 className={css(styles.statValue)}>{stat.value}</h3>
          <p className={css(styles.statTitle)}>{stat.title}</p>
        </div>
      ))}
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 1rem',
    color: '#ffffff',
    textAlign: 'center',
    gap: '32px',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      justifyContent: 'space-around',
      padding: '0 2rem',
      gap: '24px',
    },
    '@media (min-width: 1024px)': {
      padding: '0 3rem',
      gap: '40px',
    },
  },
  statItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  statValue: {
    fontSize: '48px',
    fontWeight: 400,
    color: '#102E65',
    marginBottom: '12px',
    fontFamily: '"Anton", sans-serif',
    '@media (min-width: 768px)': {
      fontSize: '60px',
      marginBottom: '14px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '72px',
      marginBottom: '16px',
    },
  },
  statTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#102E65',
    marginBottom: '6px',
    '@media (min-width: 768px)': {
      fontSize: '20px',
      marginBottom: '7px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '22px',
      marginBottom: '8px',
    },
  },
  statDescription: {
    fontSize: '14px',
    color: '#4B5563',
    lineHeight: 1.5,
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '15px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '16px',
    },
  },
})
